// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".productPackMembers{margin-bottom:2rem}.productPackMembers__title{color:#343742;font-size:2rem;font-weight:600;line-height:2.4rem;margin-bottom:.8rem}.productPackMembers__item{display:block;font-size:1.4rem;line-height:2.4rem;transition:color .3s}.productPackMembers__item:hover{color:#ff6e00}.productPackMembers__item span{color:#575766}.productPackMembers__item--hide{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
